import { render } from "./NotificationAc.vue?vue&type=template&id=2817f672&scoped=true"
import script from "./NotificationAc.vue?vue&type=script&lang=js"
export * from "./NotificationAc.vue?vue&type=script&lang=js"

import "./NotificationAc.vue?vue&type=style&index=0&id=2817f672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2817f672"]])

export default __exports__